import React from "react";
import { Button, View, Text, TouchableOpacity, Platform } from "react-native";

class ManaBtn extends React.Component {
  constructor(props) {
    super(props);
    this.title = props.title;
    this.action = props.onPress;
  }

  render() {
    const title = this.title;
    const action = this.action;

    //TODO: isolate styles in css
    return (
      <TouchableOpacity onPress={action}>
        <View
          style={{
            borderRadius: 3,
            alignItems: "center",
            justifyContent: "center",
            width: 200,
            height: 30,
            backgroundColor: "#239C9D",
          }}
        >
          <Text
            style={{ fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-Regular" }), fontSize: 15, color: "#FFFFFF" }}
          >
            {title}
          </Text>
        </View>
      </TouchableOpacity>
    );
  }
}

export default ManaBtn;
